import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter( it => {
            //console.log(it.program.id);
           if(it.program == searchText) return it;
      //return it.toLowerCase().includes(searchText);
    });
   }    
}